import { jsx } from "react/jsx-runtime";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import { validateTidalLicense } from "../../base/index.js";
function AddAPhoto(props) {
  return /* @__PURE__ */ jsx(
    AddAPhotoIcon,
    {
      "data-testid": "AddAPhoto",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "AddAPhoto",
      "data-tidal-icon-meta": "devices,photos"
    }
  );
}
AddAPhoto.tidalIconMeta = {
  categories: "devices,photos",
  name: "AddAPhoto"
};
validateTidalLicense();
export {
  AddAPhoto
};
//# sourceMappingURL=AddAPhoto.js.map
